import React from 'react';
import PropTypes from 'prop-types';
import Box from 'base-ui/dist/Box';
import Icon from 'base-ui/dist/Icon';
import Heading from 'base-ui/dist/Heading';
import Lists from 'base-ui/dist/Lists';
import NavLink from '../NavLink';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const RelatedDiseasesList = ({
  className, title, titleType, data
}) => {
  const size = data?.length;
  let content1 = [];
  let content2 = [];

  if (size === 1) {
    content1 = data;
  } else if (size >= 2) {
    const index = (size % 2 === 0) ? size / 2 : ((size - 1) / 2) + 1;

    content1 = data.slice(0, index);
    content2 = data.slice(index, size);
  }

  return (
    <Box tag="section" className={`section-anchors padding-normal ${className}`}>
      <Heading type={titleType} className="titleLine">{title}</Heading>

      <Lists style={{ verticalAlign: 'top' }}>
        {content1.map((item) => (
          <li key={item.id}>
            <NavLink
              basePath={publicRuntimeConfig.PUBLIC_URL}
              as={`${item?.permalink}`}
              to={`/category?permalink=${item?.permalink}`}
              routerStrategy={'next'}
            >
              <span>{item.title}</span>
              <Icon prefix="fas" name="chevron-right" />
            </NavLink>
          </li>
        ))}
      </Lists>

      <Lists style={{ verticalAlign: 'top' }}>
        {content2.map((item) => (
          <li key={item.id}>
            <NavLink
              basePath={publicRuntimeConfig.PUBLIC_URL}
              as={`${item?.permalink}`}
              to={`/category?permalink=${item?.permalink}`}
              routerStrategy={'next'}
            >
              <span>{item.title}</span>
              <Icon prefix="fas" name="chevron-right" />
            </NavLink>
          </li>
        ))}
      </Lists>

    </Box>
  );
};

RelatedDiseasesList.defaultProps = {
  className: '',
};

RelatedDiseasesList.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string,
  titleType: PropTypes.string,
  className: PropTypes.string
};

export default RelatedDiseasesList;
